module.exports = __webpack_public_path__ + "img/registerQrcode.91b1efe6.png";